import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getPostsError, getPostsStatus, getSinglePost } from '@store/reducers/blog/selectors';
import { editPost, getSinglePost as getSinglePostAction } from '@store/actions/blog';
import { getPermittedPermissions } from '@store/reducers/check-permission/selectors';
import Main from './Main';

const mapStateToProps = state => ({
  status: getPostsStatus(state),
  permittedPermissions: getPermittedPermissions(state),
  errors: getPostsError(state),
  post: getSinglePost(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getSinglePost: getSinglePostAction,
      editPost,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
